import { render, staticRenderFns } from "./ListVideos.vue?vue&type=template&id=0a0a29bc"
import script from "./ListVideos.vue?vue&type=script&lang=ts"
export * from "./ListVideos.vue?vue&type=script&lang=ts"
import style0 from "./ListVideos.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports